import { render, staticRenderFns } from "./AnchorTpl.vue?vue&type=template&id=c5438d1e&"
import script from "./AnchorTpl.vue?vue&type=script&lang=js&"
export * from "./AnchorTpl.vue?vue&type=script&lang=js&"
import style0 from "./AnchorTpl.vue?vue&type=style&index=0&id=c5438d1e&prod&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports